<div class="loading">
  <ng-container *ngIf="!error">
    <img src="assets/loading.svg" alt="loading" />
    <h3>Logging in...</h3>
  </ng-container>
  <div *ngIf="error" class="error">Error: {{ error.message }}</div>
</div>
